import PropTypes from 'prop-types'
import COLORS from '@web-ui-kit/colors'
import * as Sc from './AvatarButton.style'

const AvatarButton = ({
  active,
  color,
  dataTestId,
  disabled,
  id,
  initials,
  fullName,
  onClick,
  text,
}) => {
  return (
    <Sc.CustomButton
      $active={active}
      data-testid={dataTestId}
      disabled={disabled}
      id={id}
      onClick={onClick}
    >
      <Sc.CustomAvatar
        $active={active}
        color={disabled ? COLORS.NEUTRAL_400 : color}
        text={initials}
      />
      <Sc.Info>
        <Sc.CustomFullName bold variant='small'>
          {fullName}
        </Sc.CustomFullName>
        <Sc.CustomText variant='small'>{text}</Sc.CustomText>
      </Sc.Info>
    </Sc.CustomButton>
  )
}

AvatarButton.defaultProps = {
  active: false,
  dataTestId: null,
  disabled: false,
  id: null,
  text: null,
}
AvatarButton.propTypes = {
  active: PropTypes.bool,
  color: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
  disabled: PropTypes.bool,
  fullName: PropTypes.string.isRequired,
  id: PropTypes.string,
  initials: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string,
}

export default AvatarButton
